import React, { useState } from "react";


const RSSS = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="school-details-container">
      {/* School Title */}
      <header className="school-header">
        <h1 className="school-title">Rama Sr. Sec. School</h1>
        <p className="school-subtitle">Affiliated: HBSE Bhiwani</p>
      </header>

      {/* Tabs Navigation */}
      <div className="school-tabs">
        <button
          className={`school-tab-button ${activeTab === "overview" ? "active" : ""}`}
          onClick={() => handleTabChange("overview")}
        >
          Overview
        </button>
        <button
          className={`school-tab-button ${activeTab === "timings" ? "active" : ""}`}
          onClick={() => handleTabChange("timings")}
        >
          Timings
        </button>
        <button
          className={`school-tab-button ${activeTab === "admissions" ? "active" : ""}`}
          onClick={() => handleTabChange("admissions")}
        >
          Admissions
        </button>
        <button
          className={`school-tab-button ${activeTab === "gallery" ? "active" : ""}`}
          onClick={() => handleTabChange("gallery")}
        >
          Gallery
        </button>
      </div>

      {/* Tab Content */}
      <div className="school-tab-content">
        {activeTab === "overview" && (
          <div className="school-tab-panel">
            <Section
              title="Computer Science & Smart Class - Room:"
              content="The school lays special stress on computer education. There is a regular period for each class for computer science. Smart classrooms equipped with the latest technology cater to students' educational needs. Multimedia CDs are used to make learning more effective and enjoyable."
            />
            <Section
              title="Library:"
              content="The institute library has over 10,000 books and subscribes to many newspapers and journals. Students are encouraged to borrow books for developing reading habits. The library operates during school hours, throughout recess, and for 15 days during summer holidays."
            />
            <Section
              title="Laboratory:"
              content="The institute provides spacious and modern laboratories for each subject of all courses and schools. A craft workshop and multimedia facilities are also available to make the learning process more interactive and engaging."
            />
          </div>
        )}

        {activeTab === "timings" && (
          <div className="school-tab-panel">
            <Section
              title="School Timings:"
              content={
                <>
                  <p>
                    <strong>Summer:</strong> Monday to Saturday, 8:40 AM to 1:50 PM
                  </p>
                  <p>
                    <strong>Winter:</strong> Monday to Saturday, 9:10 AM to 2:20 PM or 9:10 AM to 3:00 PM
                  </p>
                </>
              }
            />
            <Section title="Summer Vacation:" content="May 25th to July 5th" />
            <Section title="Winter Break:" content="December 25th to January 5th" />
          </div>
        )}

        {activeTab === "admissions" && (
          <div className="school-tab-panel">
            <Section
              title="Registration & Admission Procedure"
              content={
                <>
                  <p>
                    1. The prospectus will be available to all aspirants on dates notified during registration.
                  </p>
                  <p>
                    2. The minimum age for admission is 2 years for Pre-Nsy. and 3+ years for Nursery (as of March 31st).
                  </p>
                  <p>
                    3. No interviews are required for Pre-Nsy. & Nursery. A formal meeting with parents and the child is conducted.
                  </p>
                </>
              }
            />
            <Section
              title="Criterion for Admission:"
              content="Admission is based strictly on merit and is subject to an admission test and interview."
            />
          </div>
        )}

        {activeTab === "gallery" && (
          <div className="school-tab-panel school-gallery">
            <img
              src="yps-thumb.jpg"
              alt="School view 1"
              className="school-gallery-image"
            />
            <img
              src="rscc2.jpg"
              alt="School view 2"
              className="school-gallery-image"
            />
            <img
              src="rscc4.jpg"
              alt="School view 3"
              className="school-gallery-image"
            />
          </div>
        )}
      </div>
    </div>
  );
};

// Reusable Section Component
const Section = ({ title, content }) => {
  return (
    <div className="school-section">
      <h3 className="school-section-title">{title}</h3>
      <div className="school-section-content">{content}</div>
    </div>
  );
};

export default RSSS;
